import { createRouter, createWebHistory } from 'vue-router';
import Login from '../login/login.vue'; // 引入 login.vue 组件

const routes = [
  {
    path: '/jump', // 默认路径
    name: 'jump',
    component: () => import('../new/BtJump.vue'), // 替换为你的主页组件
  },
  {
    path: '/', // 默认路径
    name: 'Home',
    component: () => import('../App.vue'), // 替换为你的主页组件
  },
  {
    path: '/login', // 登录页面路径
    name: 'LoginPage',
    component: Login, // 使用 login.vue 组件
    props: true
  },
  {
    path: '/index', // 登录页面路径
    name: 'Index',
    component: () => import('../index/index.vue'), // 使用 login.vue 组件
  },{
    path: '/close', // 登录页面路径
    name: 'close',
    component: () => import('../index/close.vue'), // 使用 login.vue 组件
  }, {
    path: '/Mangertx', // 登录页面路径
    name: 'Mangertx',
    component: () => import('../index/mangertx.vue'), // 使用 login.vue 组件
  },{
    path: '/home', // 登录页面路径
    name: 'newhome',
    component: () => import('../new/home.vue'), // 使用 login.vue 组件
  },{
    path: '/newWithdraw', // 登录页面路径
    name: 'newWithdraw',
    component: () => import('../new/NewWithdraw.vue'), // 使用 login.vue 组件
  },{
    path: '/personInfo', // 登录页面路径
    name: 'personInfo',
    component: () => import('../new/personInfo.vue'), // 使用 login.vue 组件
  },{
    path: '/Remind', // 登录页面路径
    name: 'Remind',
    component: () => import('../new/RemindPage.vue'), // 使用 login.vue 组件
  },{
    path: '/record', // 登录页面路径
    name: 'record',
    component: () => import('../new/NewRecord.vue'), // 使用 login.vue 组件
  },{
    path: '/notification', // 登录页面路径
    name: 'notification',
    component: () => import('../new/MessageNotification.vue'), // 使用 login.vue 组件
  },{
    path: '/announcement', // 登录页面路径
    name: 'announcement',
    component: () => import('../new/EventAnnouncement.vue'), // 使用 login.vue 组件
  }
  
];

const router = createRouter({
  history: createWebHistory(), // 使用 HTML5 模式的路由
  routes,
});

export default router;